import * as styles from './index.css';
import { Box, Text, Inline } from 'braid-design-system';
import { IconCertified } from '../../Certsy/Icons/IconCertified/IconCertified';
import { CertsyToolTip } from '../../Certsy/CertsyTooltip/CertsyTooltip';
import { CertsyVerifiedBadgeTooltipContent } from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/RoleRequirementCredentialTooltip/CertsyVerifiedBadgeTooltipContent';

interface Props {
  label: string;
  isMobile: boolean;
}

interface BadgeProps {
  label: string;
}
const Badge = ({ label }: BadgeProps) => (
  <Box
    className={styles.badge}
    paddingX="xsmall"
    borderRadius="standard"
    overflow="hidden"
    background="customDark"
  >
    <Inline space="xxsmall" alignY="center">
      <Text component="span" baseline={true}>
        <Box className={styles.icon}>
          <IconCertified />
        </Box>
      </Text>
      <Text component="span" size="xsmall" maxLines={1} baseline={false}>
        {label}
      </Text>
    </Inline>
  </Box>
);
export const VerifiedBadge = ({ label, isMobile }: Props) => {
  if (isMobile) {
    return (
      <Box display="flex" cursor="default">
        <Badge label={label} />
      </Box>
    );
  }

  return (
    <Box display="flex" cursor="default">
      <CertsyToolTip
        tooltipContent={<CertsyVerifiedBadgeTooltipContent />}
        offset={[0, 0]}
        placement="bottom-start"
        fallbackPlacements={['top-start', 'bottom-start']}
      >
        <Badge label={label} />
      </CertsyToolTip>
    </Box>
  );
};
